import { mapActions } from "vuex";

export default {
  data: () => ({}),
  methods: {
    ...mapActions('account', [
      'updateSortMapEmployees',
      'updateSortMapDealers',
    ]),
    /**
     *
     * @param field
     */
    sortEmployees(field) {
      this.updateSortMapEmployees(field)
    },
    /**
     *
     * @param field
     */
    sortDealers(field) {
      this.updateSortMapDealers(field)
    },
  },
}
